var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4724_334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.18371C16 7.63989 15.955 7.09314 15.859 6.55814H8.1604V9.63879H12.569C12.3861 10.6324 11.7983 11.5113 10.9375 12.0698V14.0687H13.5677C15.1122 12.6754 16 10.6177 16 8.18371Z",
    fill: "#996CFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16042 16C10.3617 16 12.2182 15.2915 13.5707 14.0687L10.9406 12.0698C10.2088 12.5578 9.26408 12.8341 8.16342 12.8341C6.03408 12.8341 4.22865 11.426 3.58085 9.53296H0.866699V11.5936C2.25227 14.295 5.07438 16 8.16042 16Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57792 9.53298C3.23602 8.53941 3.23602 7.46353 3.57792 6.46996V4.40933H0.866764C-0.290874 6.66985 -0.290874 9.33309 0.866764 11.5936L3.57792 9.53298Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16042 3.16589C9.32406 3.14825 10.4487 3.57743 11.2914 4.36523L13.6217 2.0812C12.1462 0.723121 10.1878 -0.0235266 8.16042 -1.02057e-05C5.07438 -1.02057e-05 2.25227 1.70493 0.866699 4.40932L3.57785 6.46995C4.22265 4.57394 6.03109 3.16589 8.16042 3.16589Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4724_334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGMail);
export default __webpack_public_path__ + "static/media/GMail.711e58bbf428f5f58269906cf7614487.svg";
export { ForwardRef as ReactComponent };